const clearAllCookies = () => {
    const cookies = document.cookie.split(';');
    for (let cookie of cookies) {
        const eqPos = cookie.indexOf('=');
        const name = eqPos > -1 ? cookie.substr(0, eqPos).trim() : cookie.trim();
        document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
        document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=${window.location.hostname}`;
    }
};

window.addEventListener('storage', (event) => {
    if (event.key === 'clearAllCookiesTrigger') {
        clearAllCookies();
    }
});

const invalidateSession = () => {
    localStorage.setItem('sessionInvalidated', new Date().toUTCString());
};

const triggerClearAllCookies = () => {
    clearAllCookies();
    localStorage.setItem('clearAllCookiesTrigger', new Date().toUTCString());
};

const clearAllCaches = async () => {
    if ('caches' in window) {
        const cacheNames = await caches.keys();
        await Promise.all(cacheNames.map(name => caches.delete(name)));
    }
};

const fmaFunctions = () => {
    return {
        login: async () => {
            if (window?.fma) {
                localStorage.clear();
                sessionStorage.clear();
                triggerClearAllCookies();
                await clearAllCaches();
                window.fma.login();
            } else {
                throw new Error("FMA not loaded. Cannot login.");
            }
        },
        logout: () => {
            if (window?.fma) {
                invalidateSession();
                window.fma.logout();
                triggerClearAllCookies();
                localStorage.removeItem("loginTimestamp")
                sessionStorage.removeItem("surveyBannerClosed")
            } else {
                throw new Error("FMA not loaded. Cannot logout.");
            }
        }
    };
};
export default fmaFunctions;
